import { FunctionComponent } from 'react'
import { Box, Typography } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { EmailInvite } from 'components/page/email-invite'
//@ts-ignore
import { useTheme } from 'styled-components'

export const InviteFriendsByEmail: FunctionComponent<{ inviteUsersByEmail: Function }> = ({ inviteUsersByEmail }) => {
  const { isDevice } = useScreenSizes()
  const theme = useTheme()

  const emails = []

  for (var i = 0; i < 4; i++) {
    emails.push(<EmailInvite key={i} onSubmit={inviteUsersByEmail} />)
  }
  return (
    <Box color={theme.colors.accent1} display="flex" flexDirection="column" width="100%">
      <Box>
        <Box>
          <Typography component="p" align={isDevice ? 'center' : 'left'}>
            Friends don't let friends miss out on being on Obsidi.
          </Typography>
        </Box>
        <Box>
          <Typography component="p" align={isDevice ? 'center' : 'left'}>
            Invite your community to the home for Black professionals by entering their emails below:
          </Typography>
        </Box>
        <Box>{emails}</Box>
      </Box>
    </Box>
  )
}
